import { useUser } from 'hooks/use-user';

export const useIsLoggedIn = () => {
    return Boolean(useUser()?.id);
};
